@if (visible()) {
  <div class="a2hs-banner" role="region" aria-label="Install Relyon">
    <span class="a2hs-icon" aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 16V4" />
        <path d="M8 8l4-4 4 4" />
        <path d="M6 12v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6" />
      </svg>
    </span>
    <span class="a2hs-text">
      Install <strong>Relyon</strong> — tap <strong>Share</strong> then
      <strong>&ldquo;Add to Home Screen&rdquo;</strong>.
    </span>
    <button type="button" class="a2hs-close" aria-label="Dismiss" (click)="dismiss()">
      &#10005;
    </button>
  </div>
}
